module.exports = __webpack_public_path__ + "img/img16.cd5a3648.svg";